import { AxiosError, AxiosResponse } from "axios";
import { deleteApi, getApi, patchApi, postApi } from "../CreateApi";
import { responseGetAllPermissions, responseGetAllRole } from "./interfaceRole";
import { rolesSystem } from "@/utils";

export const getAllRol = async (): Promise<responseGetAllRole[]> => {
  try {
    const data = await getApi("/role");
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseGetAllRole[];
  }
};

export const getAllRols = async (): Promise<any[]> => {
  try {
    const data = await getApi("/user/roles");
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any[];
  }
};

export const getAllRolId = async (id?: number): Promise<responseGetAllRole> => {
  try {
    const data = await getApi(`/role/${id}`);

    const newData = {
      ...data,
      permissions: data.permissions.map((permi: any) => ({
        ...permi,
        name: rolesSystem[permi.name] || permi.name, // Mantén el nombre original si no se encuentra en rolesSystem
      })),
    };

    return newData;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseGetAllRole;
  }
};

export const getAllPermissions = async (): Promise<
  responseGetAllPermissions[]
> => {
  try {
    const data = await getApi("/permissions");
    const newDate = data.map((role: responseGetAllPermissions) => ({
      id: role.id,
      name: rolesSystem[role.name],
    }));
    return newDate;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as responseGetAllPermissions[];
  }
};

export const postNewRol = async (body: any): Promise<any> => {
  try {
    const data = await postApi("/role", body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const patchRol = async (body: any, id?: number): Promise<any> => {
  try {
    const data = await patchApi(`/role/${id}`, body);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};

export const deleteRol = async (id: number): Promise<any> => {
  try {
    const data = await deleteApi(`/role/${id}`, id);
    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    return axiosError?.response?.data as any;
  }
};
